"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = exports.Fee = exports.Trade = void 0;
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class Trade {
}
exports.Trade = Trade;
;
class Fee {
}
exports.Fee = Fee;
;
class Response {
}
exports.Response = Response;
;
class EndPosition {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.COMPLETELY;
        this.id = 'xBifi.endPosition';
        this.entryPointID = 'xBifi';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [new MethodConfig_1.default('xBifi.endPosition', [], 'xBifi')];
    }
    proccessCallResponse(responses, isValidAddress, network) {
        const position = (responses[0] || [])[0] || [];
        const depositHandlerID = parseInt(position[0]);
        const depositTokenID = network.getHandlerTokenID(depositHandlerID);
        const depositPrice = new bifrost_number_1.default(position[2] || '0').div(this.defaultDecimals).toStr();
        const depositAmount = new bifrost_number_1.default(position[4] || '0').div(this.defaultDecimals).toStr();
        const depositAmountWithInterest = new bifrost_number_1.default(position[6] || '0').div(this.defaultDecimals);
        const depositInterestAmount = depositAmountWithInterest.minus(depositAmount).toStr();
        const borrowHandlerID = parseInt(position[1]);
        const borrowTokenID = network.getHandlerTokenID(borrowHandlerID);
        const borrowPrice = new bifrost_number_1.default(position[3] || '0').div(this.defaultDecimals).toStr();
        const borrowAmount = new bifrost_number_1.default(position[5] || '0').div(this.defaultDecimals).toStr();
        const borrowAmountWithInterest = new bifrost_number_1.default(position[7] || '0').div(this.defaultDecimals);
        const borrowInterestAmount = borrowAmountWithInterest.minus(borrowAmount).toStr();
        const collateralOutMin = new bifrost_number_1.default(position[8] || '0').div(this.defaultDecimals).toStr();
        const flashloanAmount = new bifrost_number_1.default(position[9] || '0').div(this.defaultDecimals).toStr();
        const flashloanRate = new bifrost_number_1.default(position[10] || '0').div(this.defaultDecimals).toStr();
        const uniswapAmount = new bifrost_number_1.default(position[11] || '0').div(this.defaultDecimals).toStr();
        const uniswapRate = new bifrost_number_1.default(position[12] || '0').div(this.defaultDecimals).toStr();
        const rewardAmount = new bifrost_number_1.default(position[13] || '0').div(this.defaultDecimals).toStr();
        const deposit = {
            handlerID: depositHandlerID,
            tokenID: depositTokenID,
            price: depositPrice,
            amount: depositAmount,
            interest: depositInterestAmount
        };
        const borrow = {
            handlerID: borrowHandlerID,
            tokenID: borrowTokenID,
            price: borrowPrice,
            amount: borrowAmount,
            interest: borrowInterestAmount
        };
        const flashloanFee = {
            amount: flashloanAmount,
            rate: flashloanRate
        };
        const uniswapFee = {
            amount: uniswapAmount,
            rate: uniswapRate
        };
        return {
            deposit,
            borrow,
            flashloanFee,
            uniswapFee,
            collateralOutMin,
            rewardAmount
        };
    }
}
exports.default = EndPosition;
;
//# sourceMappingURL=EndPosition.js.map